import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { type PricingCategoryFiltersUpdateApi, pricingCategoriesApiSchema } from '../../models';

const masterDataApi = fetcher.extend(() => ({ prefixUrl: `${API.MASTER_DATA_PUBLIC}` }));

export const fetchPricingCategories = async (
  filters: PricingCategoryFiltersUpdateApi,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await masterDataApi
      .get('lookup-code/PRCNCTGR', { searchParams: filters, signal })
      .json(pricingCategoriesApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn(
        'Validation error on pricing categories response',
        (error as ValiError<typeof pricingCategoriesApiSchema>).issues,
      );
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
